<template>
  <div class="modal">
    <div class="modal-body" v-on-clickaway="() => closeModal()">
      <div class="modal-header">
        <div class="modal-title">
          <h3>Vali sissetulnud arve</h3>
        </div>
        <div class="flex justify-end w-2/3 px-3"></div>
      </div>
      <div class="modal-content flex-col">
        <div class="data-container-content data-container-table">
          <div class="gwd-table nested" v-if="supplierInvoices">
            <div class="gwd-table-header grid-cols-5">
              <div class="mobile:col-span-2">
                <h4>Arve number</h4>
              </div>
              <div class="mobile:col-span-2"><h4>Järjekorranumber</h4></div>
              <div><h4>Kuupäev</h4></div>
              <div class="mobile:col-span-3"><h4>Summa käibemaksuta</h4></div>
              <div class="mobile:col-span-2"><h4>Sidumata summa</h4></div>
            </div>
            <div
              class="gwd-table-row hoverable grid-cols-5 cursor-pointer hover:bg-offwhite-light mobile:border-b mobile:border-b-offwhite-dark"
              v-for="invoice in supplierInvoices"
              :key="invoice.id"
              :class="selectedInvoice === invoice ? 'bg-primary/10' : ''"
              @click="selectedInvoice = invoice"
            >
              <div class="invoice-row-cell mobile:col-span-2">
                <span class="font-medium invoice-cell">{{
                  invoice.invoice_nr
                }}</span>
              </div>
              <div class="invoice-row-cell mobile:col-span-2">
                <span class="font-medium invoice-cell">{{
                  invoice.queue_number
                }}</span>
              </div>
              <div class="invoice-row-cell mobile:col-span-1">
                <span class="font-medium invoice-cell">
                  {{ moment(invoice.invoice_date).format("DD.MM.YYYY") }}
                </span>
              </div>
              <div class="invoice-row-cell mobile:col-span-3">
                <span class="font-medium invoice-cell">{{
                  round2(invoice.total_sum - invoice.tax_sum)
                }}</span>
              </div>
              <div class="invoice-row-cell mobile:col-span-2">
                <span class="font-medium invoice-cell">{{
                  round2(
                    invoice.total_sum -
                      invoice.tax_sum -
                      invoice.related_costs_sum
                  )
                }}</span>
              </div>
            </div>
          </div>
          <span v-if="supplierInvoices.length === 0" class="p-2">
            Seotud arved puuduvad
          </span>
        </div>
      </div>
      <div class="modal-bottom-bar">
        <button
          @click="selectedInvoice ? saveInvoice() : ''"
          class="mr-3"
          :class="selectedInvoice ? 'btn-primary' : 'btn-disabled'"
        >
          <span class="icon typcn typcn-tick" />
          <span class="label">Vali arve</span>
        </button>
        <button class="btn-danger" @click="closeModal">
          <span class="icon typcn typcn-times" />
          <span class="label">Sulge</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { round2 } from "@/assets/utils/commonMath";
import EventBus from "@/assets/mixins/EventBus";

export default {
  name: "IncomingInvoiceSelector",
  props: {
    supplier: { type: Object, required: true },
  },
  data() {
    return {
      selectedInvoice: null,
      supplierInvoices: [],
      moment: moment,
    };
  },
  methods: {
    round2,
    closeModal() {
      this.$emit("close");
    },
    saveInvoice() {
      this.$emit("save", this.selectedInvoice);
      EventBus.$emit("addInvoiceToCost", this.selectedInvoice);
      this.closeModal();
    },
    loadSupplierInvoices() {
      this.apiRequest(
        `invoice/${this.companyId}/invoices/?supplier=${this.supplier.id}&checked=false`,
        "get",
        true
      ).then((res) => {
        this.supplierInvoices = res.data.results;
      });
    },
  },
  mounted() {
    this.loadSupplierInvoices();
  },
  computed: {
    ...mapGetters({
      companyId: "companyData/activeCompanyUuid",
    }),
  },
};
</script>

<style scoped lang="scss"></style>
